import React, { useContext } from "react";
import { HelpCenterContext } from "../Context/HelpCenterContext";
import { Dialog } from "@progress/kendo-react-dialogs";
import { useHubspotForm } from '@aaronhayes/react-use-hubspot-form';
import Loader from "../../Loader/loader";

export const SubmitIdeaForm = () => {
    const { loaded, error, formCreated } = useHubspotForm({
        portalId: '22438271',
        formId: '6a12087d-1b17-4761-ac59-8fd5ea5e9044',
        target: '#submit-idea-form'
    });

    return (
        <div className="mt-4">
            {(loaded && formCreated) ? <div id="submit-idea-form"></div> : <Loader />}
        </div>
    );
};

export const SubmitIdeaDialog = () => {
    const { dispatch } = useContext(HelpCenterContext)
    return (
        <Dialog
            title={"Submit and idea"}
            onClose={() => dispatch({ type: "TOGGLE_SUBMITIDEA_DIALOG" })}
        >
            <SubmitIdeaForm />
        </Dialog>
    )
}